import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: false,
  appVersion: "3.2.0",
  logLevel: NgxLoggerLevel.TRACE,
  serverLogLevel: NgxLoggerLevel.OFF,
  signingFlowsApi:{
    uri: 'https://playground.api.docs.qsign.sk/QSignDocs/rest/signing-flows',
  },
  signingTasksApi:{
    uri: 'https://playground.api.docs.qsign.sk/QSignDocs/rest/signing-tasks',
  },
  eSignerApi:{
    uri: 'https://playground.api.docs.qsign.sk/QSignDocs/rest/esigner-api',
  },
  subscriptionApi:{
    uri: 'https://playground.api.docs.qsign.sk/QSignDocs/rest/subscriptions',
  },
  websocket:{
    uri: 'https://playground.api.docs.qsign.sk/QSignDocs/rest/ws',
  },
  keycloak: {
    authority: 'https://playground.tsp.ardaco.com',
    redirectUri: 'https://playground.docs.qsign.sk/dashboard',
    postLogoutRedirectUri: 'https://playground.docs.qsign.sk',
    realm: 'qsign_realm_playground',
    clientId: 'qsign_docs_client',
  },
  eSignerIFrame: "https://playground.tsp.ardaco.com/QSignPortal/?signId=",
  storeUrl: "https://store.ardaco.com",
  tutorialUrl: "https://www.qsign.sk/assets/video/QSign_Docs_SK.mp4",
  tspDashboardUrl: "https://playground.tsp.ardaco.com/QSignMobileDashboard"
};
